<template lang="pug">
  div(v-if="details")
    v-card(v-if="isCheckout")
      v-card-title.pb-4
        b.header-title Checkout
      v-card-text.d-flex.flex-column
        b Details: {{ checkoutDets.orderDesc }}
        b Amount: RM 1.00
        b Remarks: {{ checkoutDets.orderRemarks }}
      v-card-text
        form(id="submitPayment" action="https://payment.ipay88.com.my/ePayment/entry.asp" name="ePayment" method="post")
          input(type="hidden" name="MerchantCode" :value="merchantCode")
          input(type="hidden" name="PaymentId" value="2")
          input(type="hidden" name="RefNo" :value="suborderId")
          input(type="hidden" name="Amount" value="1.00")
          input(type="hidden" name="Currency" value="MYR")
          input(type="hidden" name="ProdDesc" :value="checkoutDets.orderDesc")
          input(type="hidden" name="UserName" value="Stephen")
          input(type="hidden" name="UserEmail" value="stephen.chai@codafuture.com")
          input(type="hidden" name="UserContact" value="0128737787")
          input(type="hidden" name="Remark" :value="checkoutDets.orderRemarks")
          input(type="hidden" name="Lang" value="UTF-8")
          input(type="hidden" name="SignatureType" value="SHA256")
          input(type="hidden" name="Signature" 
          :value="signature")
          input(type="hidden" name="ResponseURL" 
          value="https://anybook.app/complete")
          input(type="hidden" name="BackendURL" 
          value="https://api.codafuture.com/payment")
          input(class="d-none" type="submit" name="Submit")
      v-card-actions.pt-0.pb-4
        v-btn(
          class="m-auto"
          tile
          color="blue"
          @click="pay(true)"
        )
          v-icon(center) mdi-timer
          span Pay Later
        v-btn(
          class="m-auto"
          tile
          color="green"
          @click="pay(false)"
        )
          v-icon(center) mdi-cash
          span Pay Now
    v-card(v-else)
      v-card-text.pb-0
        v-textarea(
          class="p-0"
          clearable
          clear-icon="mdi-close-circle"
          label="Remarks"
          v-model="remarks"
        )
      v-card-actions.pt-0(
        v-if="$store.getters.isLoggedIn"
      )
        v-text-field(
          class="m-auto"
          ref="promoCodeField"
          label="Promo Code"
          v-model="promoCode"
          :rules="[promotionalLimitReached]"
          prepend-icon="mdi-sale"
          append-outer-icon="mdi-send"
          @click:append-outer="applyPromo"
        )
        //-v-btn(
          tile
          small
          color="primary"
          @click="getAssignedMerchantPromotions"
        //-) View Available Offers
        v-dialog(
          v-model="dialog"
          content-class="item-dialog"
          scrollable
          tile
        )
          template(
            v-slot:activator="{ on, attrs }"
          )
            v-btn(
              tile
              small
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="getAssignedMerchantPromotions(); dialog = true;"
            ) View Available Offers
          v-progress-circular(
            v-if="loading"
            indeterminate
            color="primary"
            :size="100"
          )
          v-card(v-else)
            template(v-if="!promo_merchant_list.length")
              v-card(
                  class="promotion-merchant-card"
              )
                v-card-title
                    h3.header-title(
                      style="text-align: left;"
                    ) Available Offers
                v-card-text
                    b This merchant does not currently have any offers.
            template(v-else)
              v-card(
                class="promotion-merchant-card"
              ) 
                v-card-title
                    h3.header-title Available Offers
                v-list(
                  three-line
                )
                  template(
                    v-for="(p, index) in promo_merchant_list"
                  )
                    v-card(
                      color="white"
                      class="mx-2 px-2 py-2"
                      :key="p.promo_id"
                    ) 
                      v-chip(
                        small
                        outlined
                        class="ml-4 red"
                        label text-color="red darken-4"
                      ) Limited Offer
                      v-card-text 
                        b {{ p.promo_code }}
                      v-card-text(
                        style="display: flex; justify-content: space-between;"
                      ) Valid until {{ parseDate(p.promo_enddate) }}
                        v-btn(
                          :class="'green'"
                          style="outline: none;"
                          @click="inputChosenPromoCode(p.promo_code); dialog = false;"
                        ) REDEEM
      v-card-actions.pt-0(
        v-else
      )
        em.m-auto Login to Enjoy Promotional Code
      v-card-actions.pt-0(
        v-if="!promoApplied"
        class="m-auto"
      )
        b.m-auto Total: 
          span.text-success RM {{ recalculatedSalePrice.toFixed(2) }}
      v-card-actions.pt-0(
        v-else
      ) 
        b.m-auto
          div Total: 
          .mx-2.text-warning.small.text-decoration-line-through RM {{ recalculatedSalePrice.toFixed(2) }} 
          div.text-success RM {{ finalPrice }}
        em.text-danger.small Discount: RM {{ promoDiscount }}
      v-card-actions.pt-0.pb-4
        v-btn(
          class="m-auto"
          tile
          color="green"
          @click="checkout"
        )
          v-icon(center) mdi-cash
          span Confirm Order
      v-card-actions.pt-0.pb-4
        v-checkbox(
          class="m-auto"
          v-model="test"
          label="Test ?"
        ) Test?
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import parseDate from "@/mixins/parseDate";
import Checkout from "@/views/dinein/Checkout";

export default {
  mixins: [parseDate],
  props: {
    decrypted: Object,
    details: Object,
    oriPrice: Number,
    salePrice: Number,
    minPrice: Number,
    extraPrice: Number,
    reservePax: Number
    // orderType: Number
  },
  components: {
    Checkout
  },
  data() {
    return {
      suborderId: null,
      merchantCode: "M27531",
      merchantKey: "jhr5oNPuPH",
      isCheckout: false,
      valid: false,
      dialog: false,
      remarks: "",
      test: false,
      selectedDate: null,
      selectedTable: null,
      selectedTime: null,
      staffName: "",
      promo_merchant_list: [],
      promoCode: "",
      promoApplied: null,
      isReachedPromoLimit: false,
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    signature() {
      return this.$helpers.SHA256(
        this.merchantKey +
          this.merchantCode +
          this.suborderId +
          "1.00".replace(".", "") +
          "MYR"
      );
    },
    checkoutDets() {
      return this.$store.state.customer.checkout;
    },
    cart() {
      return this.$store.getters.dinein;
    },
    promotionalLimitReached() {
      return this.isReachedPromoLimit ? "Redemption limit reached" : true;
    },
    promoDiscount() {
      return this.promoApplied
        ? (
            (this.recalculatedSalePrice * this.promoApplied.promo_salepercent) /
            100
          ).toFixed(2) > this.promoApplied.promo_salemax
          ? this.promoApplied.promo_salemax
          : (
              (this.recalculatedSalePrice *
                this.promoApplied.promo_salepercent) /
              100
            ).toFixed(2)
        : 0;
    },
    recalculatedOriPrice() {
      return this.oriPrice < this.minPrice
        ? this.oriPrice + this.extraPrice
        : this.oriPrice;
    },
    recalculatedSalePrice() {
      return this.salePrice < this.minPrice
        ? this.salePrice + this.extraPrice
        : this.salePrice;
    },
    finalPrice() {
      return (this.recalculatedSalePrice - this.promoDiscount).toFixed(2);
    }
  },
  methods: {
    getAssignedMerchantPromotions() {
      // Commented code below used for redirecting to PromotionsMerchant.vue (DEPRECATED as we are using dialog boxes to get the assigned promotions merchant code)
      // this.$router.push(`/customer/promotions_merchant?merchantId=${this.cart.merchant_id}&orderType=${this.orderType}`);

      let url = config.promoUrl();

      var json = {
        params: {
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken,
          merchant_id: this.cart.merchant_id
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.promo_merchant_list = response.body.data;
                console.log(this.promo_merchant_list);
              } else {
                this.$swal(
                  this.$t("error.get_merchant_promo_list"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_merchant_promo_list"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_merchant_promo_list"),
            response.body.message,
            "error"
          );
        });
    },
    inputChosenPromoCode(chosenPromoCode) {
      // Both lines of commented code below used for getting chosen promo code from PromotionsMerchant.vue
      //  (DEPRECATED as we are using dialog boxes to redeem assigned merchant promotion code)
      // let chosenPromoCode = this.$route.params.promoCode;

      // typeof chosenPromoCode !== "undefined" ? this.promoCode = chosenPromoCode : "";

      this.promoCode = chosenPromoCode;
    },
    checkout() {
      this.$store.commit("customer/updateCheckout", {
        orderRemarks: this.remarks == "" ? "N/A" : this.remarks,
        orderDesc:
          this.cart.merchant_id +
          " - Dine In Order: Table " +
          this.details.table_name,
        orderAmount: this.finalPrice
      });

      this.isCheckout = true;
    },
    pay(paylater) {
      let url = config.placeDineInUrl();

      var json = {
        order_id: this.decrypted.order_id,
        table_id: this.decrypted.table_id,
        order_type: 1,
        suborder_ispaylater: paylater,
        merchant_id: this.cart.merchant_id,
        store_id: this.cart.store_id,
        order_oriprice: this.recalculatedOriPrice.toFixed(2),
        order_saleprice: this.recalculatedSalePrice.toFixed(2),
        order_servicecharge: 0,
        order_sst: 0,
        order_promoapplied:
          typeof this.promoApplied === "undefined" || this.promoApplied === null
            ? ""
            : this.promoApplied.promo_id,
        order_promodiscount: this.promoDiscount,
        order_finalprice: this.finalPrice,
        order_remarks: this.remarks,
        order_list: this.cart.order_list,
        transaction_type: "online",
        customer_id: this.$store.getters.customerId,
        customer_sessiontoken: this.$store.getters.sessionToken,
        table_sessiontoken: this.decrypted.table_sessiontoken
      };

      console.log(json);

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.suborderId = response.body.data.suborder_id;
                if (this.test) this.insertPaymentData(this.suborderId);
                else $("#submitPayment").submit();
              } else {
                this.$swal(
                  this.$t("error.customer_create_order"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.customer_create_order"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.customer_create_order"),
            response.body.message,
            "error"
          );
        });
    },
    insertPaymentData(suborder) {
      let url = config.paymentRedirectUrl();

      var json = {
        test: true,
        PaymentId: 2, // MUST BE UNIQUE
        RefNo: suborder,
        Amount: 1.0,
        Currency: "RM",
        Remark: "Localhost testing",
        TransId: +new Date(), // MUST BE UNIQUE
        AuthCode: "TEST DINE IN",
        Status: "1",
        ErrDesc: "Successful",
        Signature: "STEPHEN",
        CCName: "STEPHEN",
        CCNo: "123456",
        CCBankName: "TEST BANK",
        CCCountry: "Malaysia"
      };

      console.log(json);

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.$router.push(
                  `/payment/?status=${json.Status}&o=${this.details.orderId}&id=${json.RefNo}&desc=${json.errDesc}`
                );
              } else {
                this.$swal(
                  this.$t("error.test_payment"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.test_payment"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.test_payment"),
            response.body.message,
            "error"
          );
        });
    },
    applyPromo() {
      let url = config.applyPromoUrl();

      var json = {
        merchant_id: this.cart.merchant_id,
        promo_code: this.promoCode,
        promo_type: this.$store.getters.businessType,
        customer_id: this.$store.getters.customerId,
        customer_sessiontoken: this.$store.getters.sessionToken
      };

      console.log(json);

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                // Checking for customer apply promo limit
                if (response.body.data[0].promo_usable <= 0) {
                  this.isReachedPromoLimit = true;
                  this.$refs.promoCodeField.validate();

                  return;
                }

                this.isReachedPromoLimit = false;
                this.$refs.promoCodeField.validate();

                this.promoApplied = response.body.data[0];
              } else {
                this.$swal(
                  this.$t("error.apply_promo"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.apply_promo"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.apply_promo"),
            response.body.message,
            "error"
          );
        });
    }
  }
};
</script>
